var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeeCardScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_7435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.5 265C205.678 265 265 205.678 265 132.5C265 59.3223 205.678 0 132.5 0C59.3223 0 0 59.3223 0 132.5C0 205.678 59.3223 265 132.5 265Z",
    fill: "#F9E6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8563 78.6049L94.8563 197.301C94.8563 203.316 99.7318 208.191 105.746 208.191H163.274C169.289 208.191 174.164 203.316 174.164 197.301V78.6049C174.164 72.5906 169.289 67.7151 163.274 67.7151H105.746C99.7318 67.7151 94.8563 72.5906 94.8563 78.6049Z",
    fill: "#AD9C90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8058 79.7671L97.8058 196.982C97.8058 202.125 101.974 206.293 107.117 206.293H161.897C167.04 206.293 171.208 202.125 171.208 196.982V79.7671C171.208 74.6249 167.04 70.4563 161.897 70.4563H107.117C101.974 70.4563 97.8058 74.6249 97.8058 79.7671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.443 73.2496V70.5312H150.571V73.2496C150.571 74.3271 149.696 75.2029 148.618 75.2029H120.396C119.318 75.2029 118.443 74.3271 118.443 73.2496V73.2496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.443 201.556V201.999C118.443 202.413 118.778 202.748 119.191 202.748H149.823C150.236 202.748 150.571 202.413 150.571 201.999V201.556C150.571 201.143 150.236 200.808 149.823 200.808H119.191C118.778 200.808 118.443 201.143 118.443 201.556Z",
    fill: "#AD9C90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_7435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 265,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeCardScreen);
export default __webpack_public_path__ + "static/media/employee-card-screen.f48e683d89e6aad19030694052549417.svg";
export { ForwardRef as ReactComponent };